import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import { Snackbar } from '@mui/material';

// Create the context
export const SnackbarContext = createContext(null);

// Create a provider component
export const SnackbarProvider = ({ children }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [messageQueue, setMessageQueue] = useState([]);
  const [currentMessage, setCurrentMessage] = useState('');
  const [duration, setDuration] = useState(3000);

  // Open snackbar with a message
  const openSnackbar = useCallback((newMessage, displayDuration = 3000) => {
    setMessageQueue((prevQueue) => [...prevQueue, { newMessage, displayDuration }]);
  }, []);

  // Close snackbar
  const closeSnackbar = useCallback(() => {
    setSnackbarOpen(false);
  }, []);

  // Display the next message in the queue
  useEffect(() => {
    if (messageQueue.length > 0 && !snackbarOpen) {
      const { newMessage, displayDuration } = messageQueue[0];
      setCurrentMessage(newMessage);
      setDuration(displayDuration);
      setSnackbarOpen(true);

      // Remove the message from the queue after displaying it
      setMessageQueue((prevQueue) => prevQueue.slice(1));
    }
  }, [messageQueue, snackbarOpen]);

  return (
    <SnackbarContext.Provider value={{ openSnackbar, closeSnackbar }}>
      {children}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={duration}
        message={currentMessage}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </SnackbarContext.Provider>
  );
};

// Create a custom hook for using the snackbar
export const useSnackbar = () => {
  return useContext(SnackbarContext);
};
